// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_backend: {
    url: 'https://dev.doctorbusiness.ro:8007/api/v1',
    // url: "http://192.168.1.222:8007/api/v1",
    //url: "https://backend.doctorbusiness.ro/api/v1",
  },
  firebase: {
    apiKey: "AIzaSyCzVTFNgEX_kphnF5pNEZ3vkIycLPGemdw",
    authDomain: "doctor-business-5798e.firebaseapp.com",
    databaseURL: "https://doctor-business-5798e.firebaseio.com",
    projectId: "doctor-business-5798e",
    storageBucket: "doctor-business-5798e.appspot.com",
    messagingSenderId: "335956793966",
  },
  //frontendUrl: "http://localhost:4200",
  frontendUrl: "https://dev.doctorbusiness.ro",
  heartbeatInterval: 15000, // 15 seconds in milliseconds
  enableHeartbeat: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
